export enum UserRole {
  BEGINNER = '初心者',
  EXPERIENCED = '経験者'
}
